import React, { useEffect, useRef, useState } from "react";
import Cookies from "js-cookie";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const PopupSlider = () => {
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const sliderRef = useRef(null);

  useEffect(() => {
    const popupSeen = Cookies.get("popupSeen");

    if (!popupSeen) {
      setIsPopupVisible(true);
      Cookies.set("popupSeen", "true", { expires: 7 });
    }
  }, []);

  useEffect(() => {
    if (isPopupVisible) {
      document.body.classList.add("intro-popup");
    } else {
      document.body.classList.remove("intro-popup");
    }

    return () => {
      document.body.classList.remove("intro-popup");
    };
  }, [isPopupVisible]);

  const closePopup = () => {
    setIsPopupVisible(false);
  };

  const handleNext = () => {
    if (sliderRef.current) {
      sliderRef.current.slickNext();
    }
  };

  const handlePrev = () => {
    if (sliderRef.current) {
      sliderRef.current.slickPrev();
    }
  };

  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    ref: sliderRef,
  };

  return (
    isPopupVisible && (
      <div className="popup-overlay">
        <div className="popup-slider">
          <button className="btn-close-img" onClick={closePopup}>
            <img
              src="/wp-content/uploads/2024/08/btn-popup-close.svg"
              alt="Close Popup"
            />
          </button>
          <Slider {...settings} ref={sliderRef}>
            <div className="slide">
            <div className="video-container">
              <iframe
                width="600"
                height="315"
                src="https://www.youtube.com/embed/pryzOcz97Ds"
                title="YouTube video 1"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
              
              <div className="heading-wrap">
                <img
                  src="/wp-content/uploads/2024/08/horn.svg"
                  alt="Let's Get Your Feedback"
                />
                <h2>Let's Get Your Feedback</h2>
              </div>
              <p>
                You're an earlybird user for FinditZ and we'd love to hear what
                you think! There are multiple ways to give us your feedback, so
                please let us know your thoughts.
              </p>
              <div className="btn-wrap">
                <button
                  onClick={closePopup}
                  className="bg-trans border-blue f-weight-600"
                >
                  Close
                </button>
                <button onClick={handleNext} className="primary f-weight-600">
                  Next
                </button>
              </div>
            </div>
            <div className="slide">
            <div className="video-container">
            <iframe
                width="600"
                height="315"
                src="https://www.youtube.com/embed/ozXFhGKH5bo"
                title="YouTube video 2"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
              
              <div className="heading-wrap">
                <img
                  src="/wp-content/uploads/2024/08/laptop-man.svg"
                  alt="Account Setup, Part 1"
                />
                <h2>Account Setup, Part 1</h2>
              </div>
              <p>
                Getting started with FinditZ is easy! Learn how to get your
                account set up with your email, Google, or Facebook account. It
                only takes a few minutes!
              </p>
              <div className="btn-wrap">
                <button
                  onClick={handlePrev}
                  className="bg-trans border-blue f-weight-600"
                >
                  Back
                </button>
                <button onClick={handleNext} className="primary f-weight-600">
                  Next
                </button>
              </div>
            </div>
            <div className="slide">
            <div className="video-container">
            <iframe
                width="600"
                height="315"
                src="https://www.youtube.com/embed/t4R_J-Ky67c"
                title="YouTube video 3"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
              
              <div className="heading-wrap">
                <img
                  src="/wp-content/uploads/2024/08/laptop-woman.svg"
                  alt="Account Setup, Part 2"
                />
                <h2>Account Setup, Part 2</h2>
              </div>
              <p>
                Once you're set up, there’s a lot you can do within FinditZ!
                Learn about your personal settings, favorites, messages, and
                store setup.
              </p>
              <div className="btn-wrap">
                <button
                  onClick={handlePrev}
                  className="bg-trans border-blue f-weight-600"
                >
                  Back
                </button>
                <button onClick={handleNext} className="primary f-weight-600">
                  Next
                </button>
              </div>
            </div>
            <div className="slide">
            <div className="video-container">
            <iframe
                width="600"
                height="315"
                src="https://www.youtube.com/embed/rK46nIOMzsQ"
                title="YouTube video 4"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
              
              <div className="heading-wrap">
                <img
                  src="/wp-content/uploads/2024/08/money.svg"
                  alt="Create Your First Listing"
                />
                <h2>Create Your First Listing and Sell!</h2>
              </div>
              <p>
                Now for the exciting part! It’s time to create your first
                listing and connect with other users. Learn the basics of
                listing setup.
              </p>
              <div className="btn-wrap">
                <button
                  onClick={handlePrev}
                  className="bg-trans border-blue f-weight-600"
                >
                  Back
                </button>
                <button onClick={handleNext} className="primary f-weight-600">
                  Next
                </button>
              </div>
            </div>
            <div className="slide">
            <div className="video-container">
            <iframe
                width="600"
                height="315"
                src="https://www.youtube.com/embed/uu179VKy9MM"
                title="YouTube video 5"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
              
              <div className="heading-wrap">
                <img
                  src="/wp-content/uploads/2024/08/shake-hands.svg"
                  alt="Connect With Others"
                />
                <h2>Connect With Others</h2>
              </div>
              <p>
                Once your listing is set up, it's time to connect with other
                sellers to discuss details, arrange meet-ups, and get your item
                sold!
              </p>
              <div className="btn-wrap">
                <button
                  onClick={handlePrev}
                  className="bg-trans border-blue f-weight-600"
                >
                  Back
                </button>
                <button onClick={closePopup} className="primary f-weight-600">
                  Close
                </button>
              </div>
            </div>
          </Slider>
        </div>
      </div>
    )
  );
};

export default PopupSlider;
